// extracted by mini-css-extract-plugin
module.exports = {"container":"buttons-arrow-container"};